'use strict';

/**
 * @ngdoc function
 * @name courseApp.controller:HomeController
 * @description
 * # HomeController
 * Controller of the courseApp
 */
angular.module('courseApp')
    .controller('HomeController', function (CONFIG) {
        var vm = this;
        vm.imagePath = CONFIG.imagePath;
    });
